import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import signUpReducer from './SignUp';

export default combineReducers({
  form: formReducer,
  signUp: signUpReducer,
});
